import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setJobDetail, setJobs } from "@store/actions/job.action";
import { getJobs, updateJob } from "@endpoints/job.service";
import { datePostedType, JobStatus, JobType } from "@utils/constants";
import { useForm } from "react-hook-form";
import { isNullOrEmpty } from "@utils/helperFunction";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { RootState } from "@store/reducers";
import PlusIcon from "@assets/svg/PlusIcon";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";

const CandidateRowCard = ({ data, handleCloseJob }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("this is data", data);
  return (
    <div
      // onClick={() => {
      //   dispatch(setJobDetail(data));
      //   navigate(`/job/${data?._id}/applicants`, { state: data });
      // }}
      className="grid grid-cols-[1fr_1fr_1fr_0.5fr] gap-16 items-center justify-between bg-white border-b border-[#ececec] rounded px-6 py-3 hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex items-center gap-5">
        <img src={ProfileImg} className="h-8 w-8 rounded-full" />
        <span className="font-medium text-xs">Kathryn Murphy</span>
      </div>
      <span className="text-xs text-light-black font-medium">
        04:36 pm, Sunday 12 Nov{" "}
      </span>
      <span className="text-xs text-light-black font-medium">
        Full Stack Developer
      </span>
      <span className="text-xs text-light-black font-medium">JO-123ABC</span>
      {/* {activeTab === 0 && (
          <div
            className="text-white text-xs font-medium bg-red-500 py-1.5 px-1 rounded"
            onClick={(event) => {
              event.stopPropagation();
              handleCloseJob(data._id, 3);
            }}
          >
            Close Job
          </div>
        )} */}
    </div>
  );
};

const ViewByCandidate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      search: undefined,
      searchBy: "Search by",
    },
  });
  const fields = watch();
  const { jobs } = useSelector((state: RootState) => state?.job);

  const [loading, setLoading] = useState(jobs?.length === 0);

  const fetchJobs = () => {
    getJobs(
      !isNullOrEmpty(fields?.search) && {
        filter: {
          ...(fields?.searchBy === "Search by" && {
            searchText: fields.search,
          }),
          ...(fields?.searchBy === "Industry Type" && {
            industryType: fields.search,
          }),
          ...(fields?.searchBy === "Job Type" && {
            jobType: JobType.find((x) => x.label === fields.search)?.value,
          }),
          ...(fields?.searchBy === "Date Posted" && {
            datePosted: datePostedType.find((x) => x.label === fields.search)
              ?.value,
          }),
        },
      }
    )
      .then((response) => {
        const { data, success } = response;
        if (success) {
          dispatch(setJobs(data));
        }
      })
      .finally(() => setLoading(false));
  };

  const handleCloseJob = async (jobId, status) => {
    try {
      const { success } = await updateJob({ jobId, status });
      if (success) {
        fetchJobs();
        enqueueSnackbar("Job Closed Successfully!", { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobs();
    }
  }, [fields?.search]);

  return (
    <div className="min-h-0 flex flex-col">
      <div className="grid grid-cols-[1fr_1fr_1fr_0.4fr] px-6">
        <span className="text-xs font-medium text-primary pl-10">
          Candidate Name
        </span>
        <span className="text-xs font-medium text-primary">
          Applied date and time
        </span>
        <span className="text-xs font-medium text-primary">Job position</span>
        <span className="text-xs font-medium text-primary">Job Ref.</span>
      </div>
      <div className="flex flex-col mt-4 min-h-0 overflow-y-scroll no-scrollbar border-t">
        {Array.from({length:20})?.map((job) => {
          return (
            <CandidateRowCard
              data={job}
              handleCloseJob={handleCloseJob}
            />
          );
        })}
      </div>
    </div>
  );

  return loading ? (
    <div className="gap-2.5 flex mt-16 flex-col">
      {Array.from({ length: 10 }, (x, i) => i).map((key) => {
        return (
          <div className="flex justify-between">
            <div
              style={{
                borderWidth: 1,
              }}
              className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
            >
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              <div className="h-3 rounded bg-gray-200 w-1/4"></div>
            </div>
          </div>
        );
      })}
    </div>
  ) : jobs?.length === 0 ? (
    <div className="flex flex-1 h-screen flex-col items-center justify-center">
      <p className="text-primary font-semibold">No Job created</p>
      <p className="mt-2 mb-5">Create a Job now!</p>
      <button
        onClick={() => navigate("create")}
        className="flex items-center justify-center border bg-green-600 rounded-md px-2 py-1 gap-1 text-white font-medium text-sm"
      >
        <PlusIcon className={"w-4 h-4"} fill={"white"} />
        Create Job Post
      </button>
    </div>
  ) : (
    <div className="min-h-0">
      <div className="grid grid-cols-4">
        <span className="text-xs font-medium text-primary text-center">
          Candidate Name
        </span>
        <span className="text-xs font-medium text-primary text-center">
          Applied date and time
        </span>
        <span className="text-xs font-medium text-primary text-center">
          Job position
        </span>
        <span className="text-xs font-medium text-primary text-center">
          Job Ref.
        </span>
      </div>
      <div className="flex flex-col mt-4 max-h-fit overflow-y-scroll no-scrollbar border-t">
        {jobs?.length ? (
          jobs?.map((job) => {
            return (
              <CandidateRowCard
                key={job?._id}
                data={job}
                handleCloseJob={handleCloseJob}
              />
            );
          })
        ) : (
          <div className="flex-grow">
            <span className="m-auto font-medium text-xs">No jobs found.</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewByCandidate;
